(() => {
  "use strict";

  const locale = (document.documentElement.lang || "en").slice(0, 2).toLowerCase();
  const shared = {
    "ENGELISH": "ENGLISH",
    "Engelish": "English",
    "Men&Woman": "Men & Women",
    "SEE OUR PRODUCT": "SEE OUR PRODUCTS"
  };
  const localeCopy = {
    nl: {
      "SOVAH skincare routines": "SOVAH huidverzorgingsroutines",
      "All Products": "Alle producten",
      "Skin Care": "Huidverzorging",
      "For all skin types": "Voor alle huidtypen",
      "Man&Vrouw": "Voor alle huidtypen",
      "Man & Vrouw": "Voor alle huidtypen",
      "Men & Women": "Voor alle huidtypen",
      "You may also like": "Misschien ook interessant",
      "Good to know": "Goed om te weten",
      "SEE OUR PRODUCTS": "BEKIJK ONZE PRODUCTEN",
      "BEKIJK ONS PRODUCT": "BEKIJK ONZE PRODUCTEN"
    },
    de: {
      "SOVAH skincare routines": "SOVAH Hautpflegeroutinen",
      "All Products": "Alle Produkte",
      "Skin Care": "Hautpflege",
      "For all skin types": "Für alle Hauttypen",
      "Man&Vrouw": "Für alle Hauttypen",
      "Man & Vrouw": "Für alle Hauttypen",
      "Men & Women": "Für alle Hauttypen",
      "You may also like": "Das könnte dir auch gefallen",
      "Good to know": "Gut zu wissen",
      "Speichern": "Shop",
      "SEE OUR PRODUCTS": "ALLE PRODUKTE ANSEHEN"
    },
    en: {
      "Men & Women": "For all skin types"
    }
  };
  const dictionary = { ...shared, ...(localeCopy[locale] || localeCopy.en) };

  function translateText(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const original = node.nodeValue;
      const trimmed = original.trim();
      if (!trimmed || !dictionary[trimmed]) continue;
      node.nodeValue = original.replace(trimmed, dictionary[trimmed]);
    }
  }

  function translateAttributes(root) {
    const elements = root.nodeType === Node.ELEMENT_NODE ? [root, ...root.querySelectorAll("*")] : [];
    elements.forEach((element) => {
      ["aria-label", "title"].forEach((name) => {
        const value = element.getAttribute(name);
        if (value && dictionary[value]) element.setAttribute(name, dictionary[value]);
      });
    });
  }

  function repairNavigation(root) {
    const links = root.nodeType === Node.ELEMENT_NODE && root.matches("a[href]")
      ? [root, ...root.querySelectorAll("a[href]")]
      : [...root.querySelectorAll("a[href]")];
    links.forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      const barePath = url.pathname.replace(/^\/(nl|de)(?=\/)/, "");
      let target = null;
      if (barePath === "/collections/skin-care-routines") target = "/collections/routines";
      if (!target) return;
      const prefix = locale === "nl" || locale === "de" ? `/${locale}` : "";
      link.href = `${prefix}${target}`;
    });
  }

  function normalizeCollectionHeadings() {
    const path = window.location.pathname.replace(/^\/(nl|de)(?=\/)/, "");
    if (path === "/collections/all") {
      const heading = document.querySelector("main h1");
      if (heading) {
        heading.textContent = locale === "nl"
          ? "Alle producten"
          : locale === "de"
            ? "Alle Produkte"
            : "All products";
      }
      return;
    }
    if (!["/collections/routines", "/collections/skin"].includes(path)) return;

    const headings = [...document.querySelectorAll("main h1")];
    headings.slice(1).forEach((heading) => {
      const paragraph = document.createElement("p");
      paragraph.className = heading.className;
      paragraph.textContent = locale === "nl"
        ? "Voor alle huidtypen"
        : locale === "de"
          ? "Für alle Hauttypen"
          : "For all skin types";
      heading.replaceWith(paragraph);
    });
  }

  function normalizePageHeadings() {
    const path = window.location.pathname.replace(/^\/(nl|de)(?=\/)/, "");
    if (path !== "/pages/about-us" || document.querySelector("main h1")) return;

    const oldHeading = document.querySelector("main h2");
    if (!oldHeading) return;
    const heading = document.createElement("h1");
    [...oldHeading.attributes].forEach((attribute) => {
      heading.setAttribute(attribute.name, attribute.value);
    });
    heading.innerHTML = oldHeading.innerHTML;
    oldHeading.replaceWith(heading);
  }

  function apply(root = document.body) {
    if (!root) return;
    translateText(root);
    translateAttributes(root);
    repairNavigation(root);
    normalizeCollectionHeadings();
    normalizePageHeadings();
  }

  function init() {
    apply();
    new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) apply(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();
